import { EventEmitter, Injectable } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ToastrService } from 'ngx-toastr';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { SocketService } from 'app/shared/common/helper/socket.service';

@Injectable({
    providedIn: 'root'
})

export class TodoListItemService {


    firstname;
    lastname ;
    selectedTask = new Subject();
    resetTaskForm = new Subject();
    inprogressTaskTime = new Subject();
    selectedTaskValue;
    projectChanged = new Subject<any>();
    timeSheetCreated = new Subject<any>();
    changedProjectName: Observable<any>;
    selectedTaskForHeader = new BehaviorSubject<any>('');
    selectedTaskForHeaderValue = this.selectedTaskForHeader.asObservable();
    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     * @param {Location} _location
     */
    constructor(
        private _httpClient: HttpClient,
        private _location: Location,
        private parseService: ParseService,
        private queryInterface: QueryInterface,
        private toastr: ToastrService,
        private hardCodedValues: HardCodedValues,
        private storageConfiguration: StorageConfiguration,
        private http: HttpClient,
        private _socket: SocketService

    ) {
        // Set the defaults
        this.firstname = this.parseService.instance.User.current() ? this.parseService.instance.User.current().get('firstName')
                        : '';
        this.lastname = this.parseService.instance.User.current() ?  this.parseService.instance.User.current().get('lastName')
                        : '';
        this.changedProjectName = this.projectChanged.asObservable();
    }

    sendSelectedTask(task, projectDetails): void {

        const data = {
            task,
            projectDetails
        };
        this.selectedTaskValue = data;
        this.selectedTask.next(data);
    }

    clearSelectedTask(): void {
        this.resetTaskForm.next();
    }

    project(details): void  {
        this.projectChanged.next(details);
    }

    getMessage(): Observable<any> {
        return this.selectedTask.asObservable();
    }

    getInprogressTaskTime(value): any{
        return this.inprogressTaskTime.next(value);
    }

    updateTaskForHeader(task): void {
        this.selectedTaskForHeader.next(task);
    }
    
    updateTimeSheetStatus(value): void{
        this.timeSheetCreated.next(value);
    }

}
